export default "__VITE_ASSET__cebfcd92__"